'use es6';

import http from 'hub-http/clients/apiClient';
import { getContactPropertiesKey } from 'FormsUI/earlyRequest/earlyRequestsShared';
import getFromEarlyRequest from 'forms-utils-lib/earlyRequest/getFromEarlyRequest';
import { ER_CONTACT_PROPERTIES_ALIAS } from 'FormsCommonComponents/earlyRequest/earlyRequestKeys';
const BASE_PATH_V4 = 'properties/v4';
function _getContactPropertiesGroups() {
  return http.get(`${BASE_PATH_V4}/groups/contact/with-statistics`).then(({
    results
  }) => results);
}
export function getContactPropertiesGroups() {
  return getFromEarlyRequest(getContactPropertiesKey(), () => _getContactPropertiesGroups(), {
    alias: ER_CONTACT_PROPERTIES_ALIAS
  });
}